import { InputAdornment } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { ReactComponent as Lock } from './Assets/Union.svg'
import DefaultInput from '../DefaultInput'
import { DefaultLabelTypo } from '../InputsStyled'
import styled from '@emotion/styled'
import Flag from 'Components/Elements/Flag'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'

const CountryBox = observer(props => {
    return (
        <UInputText
            disabled={true}
            value={props.value}
            variant="outlined"
            label={
                <DefaultLabelTypo variant="label">
                    <T>{props.label}</T>
                </DefaultLabelTypo>
            }
            InputProps={{
                autoComplete: 'new-password',
                autoCorrect: 'off',
                spellCheck: 'false',
                disabled: true,
                startAdornment: (
                    <InputAdornment position="start">
                        <Flag />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end" style={{ width: '10px', height: '13px' }}>
                        <Lock />
                    </InputAdornment>
                )
            }}
            inputlabelprops={{
                shrink: true
            }}
            inputProps={{ 'aria-autocomplete': 'none', autoComplete: 'new-password', spellCheck: 'false' }}
        />
    )
})

const UInputText = styled(DefaultInput)`
    &.MuiFormControl-root.MuiTextField-root {
        width: 100%;

        .MuiInputBase-root {
            border: 1px solid var(--input-border);
            background-color: #f8fafc !important;
            border-radius: 8px;
            height: 48px;
            font-family: Inter, NotoSansThai;
            .MuiInputBase-input {
                padding-left: 8px;
                color: var(--input-text);
                font-family: Inter, NotoSansThai;
                padding: 0;
            }

            .MuiOutlinedInput-notchedOutline,
            .MuiTypography-label {
                display: none;

                legend {
                    display: none;
                }
            }

            .MuiOutlinedInput-notchedOutline {
            }
        }
        .MuiTypography-label {
            display: none;
        }
    }
`

export default CountryBox
